/**
 *  유저 상세 > 유저 정보 > 유저 기본 정보
 */
export const ACCOUNT_USER_DETAIL_USER_PERSONAL_INFO_MODEL = {
  /**
   * 유저 id
   * */
  id: null,
  /**
   *  로그인 타입
   */
  loginType: null,
  /**
   *  이메일
   */
  email: null,
  /**
   *  유저 계정
   */
  account: null,
  /**
   *  핸드폰 번호
   */
  cellPhone: null,
  /**
   *  유저명
   */
  name: null,
  /**
   *  생년월일
   */
  birthday: null,
  /**
   *  성별
   */
  gender: null,
  /**
   *  친구초대 코드
   */
  referralCode: null,
  /**
   *  계정 상태
   */
  status: null,
  /**
   *  sms 수신동의
   */
  smsReceive: null,
  /**
   *  이메일 수신동의
   */
  emailReceive: null,
  /**
   *  가입일자
   */
  createDate: null,
  /**
   *  수정일자
   */
  updateDate: null,
  /**
   *  포인트
   */
  pointAmount: null,
  /**
   *  사용된 포인트
   */
  usedPointAmount: null,
  /**
   *  환불 계좌 정보
   */
  // 은행 id
  bankId: null,
  // 은행 이름
  bankName: null,
  // 예금주
  bankHolder: null,
  // 계좌 번호
  bankNumber: null,
};
